



export interface ActionT {
    type: string;
    payload: any;
}



export const ATTEMPT = 'attempt';


export const GET_ADDRESS_USER = "get_address_user";

export const LOGIN = 'login';
export const LOGIN_ATTEMPT = 'login_attempt';
export const LOGIN_ERROR = 'login_error';
export const LOGIN_SUCCESS = 'login_success';
export const REFRESH_TOKEN = 'refresh_token';
export const LOGIN_AUTH_ERROR = 'login_auth_error';

export const LOG_OUT = 'log_out';

export const UPDATE_INFO_ACCOUNT = "UPDATE_INFO_ACCOUNT"


export const UPDATE_USER_DATA = "UPDATE_USER_DATA";

export const UN_Lock_Page_Main = "UN_Lock_Page_Main"
export const Lock_Page_Main = "Lock_Page_Main"
export const CHECK_AUTH = "CHECK_AUTH"




export const GET_FCM_TOKEN = "get_fcm_token"

export const GET_ROLE_USER = 'get_role_user';



export const GET_JOB = 'get_jobs';
export const ATTEMPT_JOB = 'attempt_job';
export const JOB_ERROR = 'job_error';
export const JOB_SUCCESS_EDIT = 'job_success_edit';
export const JOB_ERROR_EDIT = 'job_error_edit';
export const JOB_CLEAR_RESULTS = 'job_clear_results';
export const JOB_REST_PAGE = 'job_rest_page';
export const JOB_REST = "job_rest";

export const JOB_SAVE_FILTER = 'job_save_filter';
export const JOB_REST_FILTER = 'job_rest_filter';

export const JOB_UPDATE_SOCKET = 'JOB_UPDATE_SOCKET';
export const JOB_NEW_SOCKET = 'JOB_NEW_SOCKET';

export const GET_WORKERS = 'GET_WORKERS';
// export const GET_WORKERS_SUCCESS = 'GET_WORKERS_SUCCESS';
export const GET_WORKERS_ERROR = 'GET_WORKERS_ERROR';


export const FINISH_ATTEMPT = 'FINISH_ATTEMPT';

export const FINISH_ATTEMPT_JOB = 'FINISH_ATTEMPT_JOB';

export const Job_SUCCESS_SEND_INFO_MODFIY = "Job_SUCCESS_SEND_INFO_MODFIY";
export const Job_SUCCESS_DELETE = "Job_SUCCESS_DELETE";


export const GET_Autocomplete_JOB_CREW_SUCCESS = "get_autocomplete_job_crew_success";

export const CHOOSE_EDIT_JOBS = 'choose_edit_jobs';


export const GET_CITIES = 'get_cities';

export const APPROVE_LABORER_SUCCESS = 'APPROVE_LABORER_SUCCESS';
export const APPROVE_LABORER_ERROR = 'APPROVE_LABORER_ERROR';

export const REJECT_LABORER_SUCCESS = 'REJECT_LABORER_SUCCESS';
export const REJECT_LABORER_ERROR = 'REJECT_LABORER_ERROR';

export const SIGN_LABORER_IN_JOB = "SIGN_LABORER_IN_JOB";
export const SIGN_LABORER_IN_JOB_SUCCESS = "SIGN_LABORER_IN_JOB_SUCCESS";
export const SIGN_LABORER_IN_JOB_ERROR = "SIGN_LABORER_IN_JOB_ERROR";


export const OPEN_REGISTER_NEW_WORKERS = 'open_register_new_workers';

export const ATTEMPT_EXPENSES = "ATTEMPT_EXPENSES";
export const GET_EXPENSES = "GET_EXPENSES";
export const GET_EXPENSES_SUCCESS = "GET_EXPENSES_SUCCESS";
export const GET_EXPENSES_ERROR = "GET_EXPENSES_ERROR";

export const EXPENSES_CLEAR_RESULTS = "EXPENSES_CLEAR_RESULTS";

export const ATTEMPT_ASSETS = "ATTEMPT_EXPENSES";
export const GET_ASSETS = "GET_ASSETS";
export const GET_ASSETS_SUCCESS = "GET_ASSETS_SUCCESS";
export const GET_ASSETS_ERROR = "GET_ASSETS_ERROR";



export const ASSETS_CLEAR_RESULTS = "ASSETS_CLEAR_RESULTS";



export const ATTEMPT_REPORTES = "ATTEMPT_REPORTES";
export const GET_REPORTES = "GET_REPORTES";
export const GET_REPORTES_SUCCESS = "GET_REPORTES_SUCCESS";
export const GET_REPORTES_ERROR = "GET_REPORTES_ERROR";


export const ATTEMPT_ENTITIES = "ATTEMPT_ENTITIES";
export const GET_ENTITIES = "GET_ENTITIES";
export const GET_ENTITIES_SUCCESS = "GET_ENTITIES_SUCCESS";
export const GET_ENTITIES_ERROR = "GET_ENTITIES_ERROR";
export const ENTITIES_CLEAR_RESULTS = "ENTITIES_CLEAR_RESULTS";



export const CLEAR_STORE_REDUCER = "CLEAR_STORE_REDUCER";




export const ATTEMPT_REFERRER = "ATTEMPT_REFERRER";
export const GET_REFERRER = "GET_REFERRER";
export const GET_REFERRER_SUCCESS = "GET_REFERRER_SUCCESS";
export const GET_REFERRER_ERROR = "GET_REFERRER_ERROR";
export const REFERRER_CLEAR_RESULTS = "REFERRER_CLEAR_RESULTS";



export const ATTEMPT_REFERRERS = "ATTEMPT_REFERRERS";
export const GET_REFERRERS = "GET_REFERRERS";
export const GET_REFERRERS_SUCCESS = "GET_REFERRERS_SUCCESS";
export const GET_REFERRERS_ERROR = "GET_REFERRERS_ERROR";
export const REFERRERS_CLEAR_RESULTS = "REFERRERS_CLEAR_RESULTS";




export const SOCKET_CONNECT = "SOCKET_CONNECT";
export const SOCKET_CONNECTED = "SOCKET_CONNECTED";
export const SOCKET_EMIT = "SOCKET_EMIT";
export const SOCKET_DISCONNECT = "SOCKET_DISCONNECT";
export const SOCKET_ON = "SOCKET_ON"


/** GPS */

export const GPS_RUNNING = "GPS_RUNNING";
export const GPS_START = "GPS_START";
export const GPS_STOP = "GPS_STOP";
export const GPS_FOREGROUND = "GPS_FOREGROUND";
export const GPS_BACKGROUND = "GPS_BACKGROUND";
export const GPS_UPDATE_LOCATION = "GPS_UPDATE_LOCATION";
export const GPS_CHECK_STATUS = "GPS_CHECK_STATUS";
export const GPS_ERROR = "GPS_ERROR"

/** Settings **/
export const UPDATE_SEE_VEHICLE_VENDORS = 'UPDATE_SEE_VEHICLE_VENDORS'


export const getOptionsActions = (nameReducer) => {
    const arr = {};
    arr["ATTEMPT"] = nameReducer + "_" + "ATTEMPT";
    arr["SUCCESS"] = nameReducer + "_" + "SUCCESS";
    arr["GET"] = nameReducer + "_" + "GET";
    arr["ERROR"] = nameReducer + "_" + "ERROR";

    return arr;
}







